import API_BASE_URL from './config';
import React, { useState } from 'react';

function RegisterKennel({ playerId }) {
  const [kennelName, setKennelName] = useState('');
  const [kennelPrefix, setKennelPrefix] = useState('');
  const [kennelSuffix, setKennelSuffix] = useState('');
  const [stashLink, setStashLink] = useState('');
  const [message, setMessage] = useState('');

  const handleAddKennel = async () => {
    if (!playerId) {
      setMessage('Please log in to register a kennel.');
      return;
    }
    if (!stashLink) {
      setMessage('Please provide a Sta.sh link for your kennel artwork.');
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/add-kennel`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          playerId,
          kennelName,
          kennelPrefix,
          kennelSuffix,
          stashLink
        })
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setMessage(data.message);
      setKennelName('');
      setKennelPrefix('');
      setKennelSuffix('');
      setStashLink('');
    } catch (error) {
      setMessage('Add kennel failed: ' + error.message);
    }
  };

  if (!playerId) return <p style={{ textAlign: 'center', color: '#888' }}>Please log in to register a kennel!</p>;

  const inputStyle = {
    width: '100%',
    padding: '8px',
    marginBottom: '15px',
    borderRadius: '5px',
    border: '1px solid #BBDEFB',
    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
    fontSize: '1em'
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#1E88E5',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
    width: '100%'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    color: '#1E88E5'
  };

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '0 auto', 
      padding: '20px', 
      backgroundColor: '#f9f9f9', 
      borderRadius: '8px', 
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)', 
      border: '1px solid #E6F0FA' 
    }}>
      <h1 style={{ 
        color: '#1E88E5', 
        textAlign: 'center', 
        marginBottom: '20px', 
        fontSize: '1.8em' 
      }}>
        Register a Kennel
      </h1>
      {message && (
        <p style={{ 
          backgroundColor: '#BBDEFB', 
          padding: '10px', 
          borderRadius: '5px', 
          color: '#333', 
          textAlign: 'center', 
          marginBottom: '20px' 
        }}>
          {message}
        </p>
      )}
      <div>
        <label style={labelStyle} htmlFor="kennelName">Kennel Name:</label>
        <input
          type="text"
          id="kennelName"
          value={kennelName}
          onChange={(e) => setKennelName(e.target.value)}
          placeholder="Kennel Name"
          style={inputStyle}
          required
        />
      </div>
      <div>
        <label style={labelStyle} htmlFor="kennelPrefix">Kennel Prefix:</label>
        <input
          type="text"
          id="kennelPrefix"
          value={kennelPrefix}
          onChange={(e) => setKennelPrefix(e.target.value)}
          placeholder="Prefix"
          style={inputStyle}
          required
        />
      </div>
      <div>
        <label style={labelStyle} htmlFor="kennelSuffix">Kennel Suffix (optional):</label>
        <input
          type="text"
          id="kennelSuffix"
          value={kennelSuffix}
          onChange={(e) => setKennelSuffix(e.target.value)}
          placeholder="Suffix"
          style={inputStyle}
        />
      </div>
      <div>
        <label style={labelStyle} htmlFor="stashLink">Sta.sh Link:</label>
        <input
          type="url"
          id="stashLink"
          value={stashLink}
          onChange={(e) => setStashLink(e.target.value)}
          placeholder="https://sta.sh/example"
          style={inputStyle}
          required
        />
      </div>
      <button
        onClick={handleAddKennel}
        style={buttonStyle}
        onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#1E88E5'}
      >
        Submit Kennel
      </button>
    </div>
  );
}

export default RegisterKennel;